const periodResources = {
    placeholder: 'Select Month',
    periodFromIDLabel: 'Start visit month',
    periodToIDLabel: 'End visit month',
};

export default periodResources;